import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ManpowerPlanVsActualPoupComponent } from 'src/app/shared/popups/manpower-plan-vs-actual-poup/manpower-plan-vs-actual-poup.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { OrgStructColorPalatteComponent } from './org-struct-color-palatte/org-struct-color-palatte.component';
import { orgStructColors, OrgStructureServService } from './org-structure-serv.service';
import { LoaderService } from 'src/app/service/loader/loader.service';

@Component({
  selector: 'app-organizational-structure',
  templateUrl: './organizational-structure.component.html',
  styleUrls: ['./organizational-structure.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class OrganizationalStructureComponent implements OnInit {
  loggedInUserCompanyID: any
  loggedInCompanyFiscalyear: any;
  loggedInUserId: any;
  buttonColorName: any;
  loggedInUserRole: any;
  selectedYear: any;
  fromYear: any;
  toYear: any;
  selectedMonth: any;
  onUpDownlaodArrow: boolean = false;
  onDownDownlaodArrow: boolean = true;
  toggleDownloadBtn: boolean = false;
  hideSubbordinates: boolean = false;

  loggedInCompanyMDID: any;
  companyYears: any = [];
  getYearMonth: any = [];
  onLoadOrganizationData: any[] = [];

  getOrganizationData: any[] = [];
  organizationData: any[] = [];
  orgStructColors: orgStructColors = structuredClone(this.orgStructureServService.orgStructDefaultColors);

  getDepartmentData: any = [];
  selectDepartment: any;
  vacantCount: any;
  showOnlyVacant: boolean = false;
  currentChartClass = 'org-chart';

  zoomLevel: number = 1;

  getMonthsByFiscalandReviewCycle: any;
  selectedYearReviewCycle: any;
  fromDate: any;
  toDate: any;
  selectedReviewCycle: any = [];
  getMonthsByFiscalandReviewCycleForReport: any = [];
  getAnnouncementTableData: any = [];

  constructor(private httpService: HttpService, private config: Config, private encryptionService: EncryptionService, public sharedService: SharedService, public dialog: MatDialog, public mobileResponsiveService: MobileResponsiveService, private orgStructureServService: OrgStructureServService, private loader: LoaderService) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    if (sessionStorage.getItem('loggedInCompanyMDID')) {
      this.loggedInCompanyMDID = this.encryptionService.decryptData(sessionStorage.getItem('loggedInCompanyMDID'));
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    window.onload = function () {
      const orgChart: any = document.querySelector('.org-chart');
      orgChart.scrollLeft = (orgChart.scrollWidth - orgChart.clientWidth) / 2;
      orgChart.scrollTop = (orgChart.scrollHeight - orgChart.clientHeight) / 2;
    };

    // Set colors for org structure
    this.getOrSetOrgColors('get');
  }

  ionViewWillEnter() {
    this.getpmsyearlist();
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.companyYears = [];
      const currentYear = new Date().getFullYear();

      const filteredYearRanges = data?.data?.yearRanges?.filter((range: string) => {
        const [fromYear, toYear] = range.split('_').map(Number);

        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          return toYear <= currentYear;
        } else {
          return fromYear <= currentYear;
        }
      });
      filteredYearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        };
        this.companyYears.push(obj);
      });
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }

      let selectedYearIndex = this.companyYears.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }

      this.selectedYear = this.companyYears[selectedYearIndex]?.year;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      this.getFiscalYearMonths();
      this.getPMSMonth();
    });
  }

  getFiscalYearMonths() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }
    this.httpService.callPostService(this.config.getFiscalYearMonths, request).subscribe((result: any) => {
      this.getYearMonth = result.data;
      const currentMonthIndex = new Date().getMonth();
      this.selectedMonth = this.getYearMonth[currentMonthIndex];

      this.getDeptForOrgStructure()
      this.getCompanyNameByCompany();
      this.getOrgStructure(true);
    })
  }

  getDeptForOrgStructure() {
    this.getDepartmentData = [];
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": null,
      "fromYear": this.fromYear,
      "month": this.selectedMonth,
      "toYear": this.toYear,
      "userId": this.loggedInCompanyMDID
    }
    this.httpService.callPostService(this.config.getDeptOrgStructure, request).subscribe({
      next: (result: any) => {
        if (result?.status && result?.data?.length) this.getDepartmentData = result?.data;
        // if(window.innerWidth <= 800){ this.selectDepartment = this.getDepartmentData[0] }
      },
      error: (err) => { }
    })
  }

  onYearChange(event: any) {
    this.selectDepartment = null;
    var selectedyear = event.value?.split('-');
    this.fromYear = selectedyear[0];
    this.toYear = selectedyear[1];

    this.getDeptForOrgStructure();
    this.getOrgStructure(true);
  }

  onMonthChange(data: any) {
    if (data) {
      this.selectDepartment = null;
      this.getDeptForOrgStructure();
      this.getOrgStructure(true);
    }
  }


  /* Actual Code to get Data of orginazation */
  getOrgStructure(onLoad = false) {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "month": this.selectedMonth,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "userId": this.loggedInCompanyMDID
    }
    this.httpService.callPostService(this.config.getOrgStructure, request).subscribe((result: any) => {
      if (result?.status && result?.data?.length) {
        this.getOrganizationData = result?.data;

        if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Admin') {
          const orgData = structuredClone(this.getOrganizationData);
          const id: any = Number(this.loggedInUserId)
          const filteredData = this.findMatchingDept(orgData, id);
          this.organizationData = filteredData ? [filteredData] : [];

          if (this.organizationData[0] == null) this.organizationData = [];

          this.organizationData = onLoad ? this.keepOnlyFirstLevel(this.organizationData) : this.organizationData;

          this.vacantCount = this.countVacantEmployees(this.organizationData);
        } else {
          this.organizationData = structuredClone(this.getOrganizationData);
          // const id:any = this.organizationData.map((ele: any) => ele?.id);

          if (this.organizationData[0] == null) this.organizationData = [];

          this.organizationData = onLoad ? this.keepOnlyFirstLevel(this.organizationData) : this.organizationData;
          this.vacantCount = this.countVacantEmployees(this.organizationData);
        }
        if (this.selectDepartment) {
          // this.organizationData = this.filterByDepartment(this.organizationData, this.selectDepartment);
        }
      }
    });
  }

  keepOnlyFirstLevel(data: any[], level: number = 1): any[] {
    return data.map(node => ({ ...node, showChildren: level === 1 ? true : false, subordinates: node.subordinates ? this.keepOnlyFirstLevel(node.subordinates, level + 1) : [] }));;
  }

  // filterByDepartment(data: any[], department: string): any[] {
  //   return data
  //     .filter(item => item.department === department)
  //     .map(item => ({
  //       ...item,
  //       subordinates: item.subordinates ? this.filterByDepartment(item.subordinates, department) : []
  //     }));
  // }
  onChangecompany(event: any) {
    if (event) {
      this.companyName = event;
      this.organizationData = event ? this.filterByCompanyName(structuredClone(this.getOrganizationData), event) : this.keepOnlyFirstLevel(structuredClone(this.getOrganizationData));

      console.log("company name is ...........", this.organizationData);
    } else {
      this.getOrgStructure(true);
      this.selectDepartment=null;
      this.onChangeDepartment(null)
    }
  }

  onChangeDepartment(data: any) {
    // this.organizationData = structuredClone(this.getOrganizationData); // Show Default all
    this.organizationData = data ? this.filterByDepartment(structuredClone(this.getOrganizationData), data) : this.keepOnlyFirstLevel(structuredClone(this.getOrganizationData));

    // const selectedDepartment = data;

    // Recursive function to filter nodes based on the department
    // const filterByDepartment = (nodes: any[], department: string): any[] => {
    //   return nodes
    //   .filter((node) => node.department === department || department === '')
    //   .map((node) => ( { ...node, subordinates: filterByDepartment(node.subordinates || [], department)} ))
    //   .filter((node) => node.department === department || node.subordinates.length > 0);
    // };

    // if (selectedDepartment) {
    //   // this.organizationData = filterByDepartment(this.organizationData, selectedDepartment);
    // }
    // else {
    //   // this.organizationData = [...this.organizationData];
    // }
  }

  filterByDepartment(data: any[], department: string): any[] {
    return data
      .map(node => {
        // Recursively filter subordinates
        const filteredSubs = this.filterByDepartment(node.subordinates || [], department);

        if (node.department === department || filteredSubs.length > 0) {
          return { ...node, subordinates: filteredSubs };
        }

        return null;
      })
      .filter((node): node is any => node !== null);
  }

  /**
   * Recursively filter organization tree by company name.
   * Returns nodes whose `companyName` matches the provided value or
   * nodes that have descendants that match (preserves tree structure).
   */
  filterByCompanyName(data: any[], companyName: string): any[] {
    if (!companyName) return structuredClone(data);

    return data
      .map(node => {
        const filteredSubs = this.filterByCompanyName(node.subordinates || [], companyName);

        if (node.companyName === companyName || filteredSubs.length > 0) {
          return { ...node, subordinates: filteredSubs };
        }

        return null;
      })
      .filter((node): node is any => node !== null);
  }



  findMatchingDept(data: any[], loggedInUserId: number): any {
    for (const node of data) {
      if (node.id === loggedInUserId) return node;

      if (node.subordinates && node.subordinates.length > 0) {
        const matchingNode = this.findMatchingDept(node.subordinates, loggedInUserId);
        if (matchingNode) return matchingNode;
      }
    }
    return null;
  }

  countVacantEmployees(data: any[]): number {
    let count = 0;
    function traverse(subordinates: any[]): void {
      subordinates.forEach((employee) => {
        if (employee?.isVacant) count++;
        if (employee?.subordinates && employee?.subordinates.length > 0) traverse(employee?.subordinates);
      });
    }
    traverse(data);
    return count;
  }


  getPMSMonth() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear
    }
    this.httpService.callPostService(this.config.getMonths, request).subscribe((data: any) => {
      this.selectedReviewCycle = [];
      this.getMonthsByFiscalandReviewCycleForReport = []
      this.getMonthsByFiscalandReviewCycle = data.data?.months;
      data.data?.months?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: this.sharedService.transform(ele)
        }
        this.getMonthsByFiscalandReviewCycleForReport.push(obj)
      });
      this.selectedYearReviewCycle = data.data?.reviewCycle;
      const currentMonthIndex = new Date().getMonth();
      let selectedIndex = 0;
      const today = new Date();
      const month = today.toLocaleString('default', { month: 'long' });
      if (this.selectedYearReviewCycle == 'Monthly') {
        this.getMonthsByFiscalandReviewCycle.forEach((ele: any) => {
          var checkMonth = ele?.split('-');
          if (month == checkMonth[0]) {
            this.fromDate = ele;
            this.toDate = ele;
            this.selectedReviewCycle.push({ id: ele, name: this.sharedService.transform(ele) });
          }
        });
      }

      if (this.selectedYearReviewCycle == 'Quarterly' || this.selectedYearReviewCycle == 'Semi_Annually' || this.selectedYearReviewCycle == 'Annually') {
        for (let range of this.getMonthsByFiscalandReviewCycle) {
          const [start, end] = range?.split('-');
          const startMonthIndex = this.getMonthIndex(start);
          const endMonthIndex = this.getMonthIndex(end);

          if ((currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) || (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))) {
            this.fromDate = range;
            this.toDate = range;
            this.selectedReviewCycle.push({ id: range, name: this.sharedService.transform(range) });
          }
        }
      }
    })
  }

  getMonthIndex(monthName: string): number {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }

  addTitleAndFiltersInfo = '';
  exportTableToPDF(elementId: string) {
    // this.loader.simpleLoader();
    this.addTitleAndFiltersInfo = this.headersForDownload();

    this.currentChartClass = 'exportToPng';
    const element = document.getElementById(elementId);

    if (!element) {
      console.error('Element not found');
      return;
    }

    const originalWidth = element.scrollWidth;
    const originalHeight = element.scrollHeight;

    const MAX_CANVAS_SIZE = 52767;
    const scale = Math.min(1, MAX_CANVAS_SIZE / Math.max(originalWidth, originalHeight));

    setTimeout(() => {
      html2canvas(element, {
        width: Math.min(originalWidth, MAX_CANVAS_SIZE),
        height: Math.min(originalHeight, MAX_CANVAS_SIZE),
        scale: scale,
        useCORS: true,
        backgroundColor: null,
        logging: false,
        allowTaint: true,
        ignoreElements: (element) => {
          return element.classList.contains('ignore-in-export');
        },
        onclone: (document) => {
          const clonedElement = document.getElementById(elementId);
          if (clonedElement) {
            clonedElement.style.backgroundColor = 'transparent';
            clonedElement.style.background = 'transparent';
          }
        }
      }).then((canvas) => {
        try {
          const imgData = canvas.toDataURL('image/png');

          if (!imgData || imgData.length < 100) {
            throw new Error('Invalid image data');
          }

          const pdf = new jsPDF('p', 'mm', 'a4');
          const pageWidth = pdf.internal.pageSize.width;
          const pageHeight = pdf.internal.pageSize.height;

          const imgWidth = pageWidth;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          pdf.addImage(
            imgData,
            'PNG',
            0,
            0,
            imgWidth,
            imgHeight,
            '',
            'FAST'
          );

          pdf.save('org_chart.pdf');
        } catch (error) {
          console.error('PDF export error:', error);
        }

      }).catch((err) => {
        console.error('Canvas rendering error:', err);
      });

      this.addTitleAndFiltersInfo = '';
    }, 200);

    setTimeout(() => {
      // this.loader.dismissLoader();
      this.currentChartClass = 'org-chart';
    }, 1000);
  }

  // This org chart with background color 
  exportToPng(elementId: string, fileName: string): void {
    // this.loader.simpleLoader();
    this.addTitleAndFiltersInfo = this.headersForDownload();

    const element = document.getElementById(elementId);
    this.currentChartClass = 'exportToPng';

    if (!element) {
      console.error('Element not found with ID:', elementId);
      return;
    }

    const originalWidth = element.scrollWidth;
    const originalHeight = element.scrollHeight;

    const MAX_CANVAS_SIZE = 52767;
    const scale = Math.min(1, MAX_CANVAS_SIZE / Math.max(originalWidth, originalHeight));

    setTimeout(() => {
      html2canvas(element, {
        width: Math.min(originalWidth, MAX_CANVAS_SIZE),
        height: Math.min(originalHeight, MAX_CANVAS_SIZE),
        scale: scale,
        useCORS: true,
        backgroundColor: '#FFFFFF', // Set white background
        logging: false,
        allowTaint: true,
        ignoreElements: (element) => {
          return element.classList.contains('ignore-in-export');
        },
        onclone: (document) => {
          const clonedElement = document.getElementById(elementId);
          if (clonedElement) {
            clonedElement.style.backgroundColor = 'white';
            clonedElement.style.background = 'white';
          }
        }
      })
        .then((canvas) => {
          canvas.toBlob((blob) => {
            if (blob) {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `${fileName}.png`;
              link.click();

              // Revoke the object URL to free up memory
              URL.revokeObjectURL(link.href);
            }
          }, 'image/png');
        })
        .catch((err) => {
          console.error('PNG export error:', err);
        });

      this.addTitleAndFiltersInfo = '';
    }, 200);


    setTimeout(() => {
      // this.loader.dismissLoader();
      this.currentChartClass = 'org-chart';
    }, 2000);
  }

  headersForDownload() {
    const financialYear = this.sharedService.transformYearToFyFormat(this.selectedYear);
    return `
    <div class="download-headers p-20">
    <p class="mb-10 fs-22 phi-fw-b">Organizational Structure</p>
    <p class="fs-18 color-262626">${this.selectedYear ? '<span class="phi-fw-600 black_color">Year:</span> ' + financialYear : ''} &nbsp ${this.selectedMonth ? '<span class="phi-fw-600 black_color">Month:</span> ' + this.selectedMonth : ''} &nbsp ${this.selectDepartment ? '<span class="phi-fw-600 black_color">Department:</span> ' + this.selectDepartment : ''}</p>
    </div>
    `;
  }


  toggleVacantFilter() {
    this.showOnlyVacant = !this.showOnlyVacant;
  }

  zoomIn() { this.zoomLevel += 0.1; }
  zoomOut() { if (this.zoomLevel > 0.2) this.zoomLevel -= 0.1; }

  toggleDownloadBtnFn() {
    this.toggleDownloadBtn = !this.toggleDownloadBtn;
  }
  getListOfCompanyNameOfComp: any = []
  companyName: any;
  getCompanyNameByCompany() {
    this.httpService.callGetService(this.config.getCompanyNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfCompanyNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfCompanyNameOfComp.push(obj);
      });
      this.getListOfCompanyNameOfComp = this.getListOfCompanyNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  onClickOpenManpowerPlanVsActualPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidth1300AndBelow;
    dialogConfig.data = {
      fromYear: this.fromYear,
      toYear: this.toYear,
      month: this.selectedMonth
    };
    dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
    this.dialog.open(ManpowerPlanVsActualPoupComponent, dialogConfig);
  }

  getOrSetOrgColors(postType: string, data?: any) {
    const apiRequest = postType === 'get' ? this.httpService.callGetService(this.config.getOrgStrCompanyColor + this.loggedInUserCompanyID) : this.httpService.callPostService(this.config.getOrgStrCompanyColor + this.loggedInUserCompanyID, data);

    // API CALL to get colors
    apiRequest.subscribe({
      next: (value) => {
        this.setColorPalletColors(value);
      },
      error: (err) => {
        this.setColorPalletColors(this.orgStructColors);
      },
    });
  }

  onOpenColorPallet() {
    const successdialogRef = this.dialog.open(OrgStructColorPalatteComponent, {
      disableClose: true,
      maxWidth: this.mobileResponsiveService.modelMaxWidth992AndBelow,
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: structuredClone(this.orgStructColors),
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getOrSetOrgColors('post', result);
      }
    });
  }

  setColorPalletColors(orgStructColors: orgStructColors | {}) {
    Object.assign(this.orgStructColors, orgStructColors);

    const root = document.documentElement;
    Object.entries(this.orgStructColors).forEach(([key, value]) => { root.style.setProperty(`--${key}`, value); });
  }
}
